import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GuidanceService } from 'src/app/admin/services/guidance/guidance.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';

@Component({
  selector: 'app-edit-guidance-detail',
  templateUrl: './edit-guidance-detail.component.html',
  styleUrls: ['./edit-guidance-detail.component.scss'],
  standalone: false
})
export class EditGuidanceDetailComponent implements OnInit {

  tinymceConfig = {
    height: 500,
    menubar: true,
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks code fullscreen',
      'insertdatetime media table paste code help wordcount'
    ],
    toolbar:
      'undo redo | formatselect | bold italic backcolor | ' +
      'alignleft aligncenter alignright alignjustify | ' +
      'bullist numlist outdent indent | removeformat | help'
  };

  constructor(
    private userdata: UserdataService,
    private spinner: NgxSpinnerService,
    private guidanceService: GuidanceService,
    private router: ActivatedRoute,
    private toast: ToastrService,
    private route: Router,
  ) { }

  data: any = '';
  id: any = '';

  ngOnInit(): void {
    this.id = this.router.snapshot.paramMap.get('id')
    this.getDataById()
    this.getCategoriesList()
    this.getCardsList()
  }


  categories: any[] = []

  getCategoriesList() {
    this.spinner.show()
    this.guidanceService.getGuidanceCategory({}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.categories = res.data;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }
  cards: any[] = []

  getCardsList() {
    this.spinner.show()
    this.guidanceService.getGuidanceCards({}).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.cards = res.data;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  formGroup = new FormGroup({
    _id: new FormControl('', Validators.required),
    guidanceCategoryId: new FormControl('', Validators.required),
    guidanceCardId: new FormControl('', Validators.required),
    guidanceDetail: new FormControl('', Validators.required),
    guidanceBrief: new FormControl(''),
  });

  getDataById() {
    this.spinner.show()
    this.guidanceService.getSingleGuidanceDetail({ _id: this.id }).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.formGroup.patchValue({ _id: res.data._id });
        this.formGroup.patchValue({ guidanceCategoryId: res.data.guidanceCategoryId._id });
        this.formGroup.patchValue({ guidanceCardId: res.data.guidanceCardId._id });
        this.formGroup.patchValue({ guidanceDetail: res.data.guidanceDetail });
        this.formGroup.patchValue({ guidanceBrief: res.data.guidanceBrief });
      },
      err => {
        this.spinner.hide()
        this.route.navigateByUrl('/admin/guidance-detail/list')
      }
    )
  }

  get f() {
    return this.formGroup.controls
  }


  /* ***********
  Update  Category
 *********** */

  public submit() {
    this.spinner.show()
    this.guidanceService.updateGuidanceDetail(this.formGroup.value).subscribe(
      (res: any) => {
        if (res.success) {
          this.spinner.hide()
          this.toast.success(res.message, 'Success')
          this.route.navigateByUrl('/admin/guidance-detail/list')
        }
        else {
          this.spinner.hide()
          this.toast.error(res.message)
        }
      },
      err => {
        this.spinner.hide()
        this.toast.error('Something went wrong!', 'Error');
      })
  }

}
